import React from 'react'
import { styled } from '@mui/material/styles'
import { Toolbar, ToolbarProps } from 'ra-ui-materialui'
import { useFormState } from 'react-hook-form'
import { DeleteWithConfirmButton, SaveButton } from 'react-admin'

const PREFIX = 'WithDeleteModalToolbar'

const classes = {
  toolbar: `${PREFIX}-toolbar`,
}

const StyledToolbar = styled(Toolbar)({
  [`&.${classes.toolbar}`]: {
    display: 'flex',
    justifyContent: 'space-between',
  },
})

const WithDeleteModalToolbar: React.FC<ToolbarProps> = (props) => {
  const { isDirty } = useFormState()

  return (
    <StyledToolbar {...props} className={classes.toolbar}>
      <SaveButton disabled={!isDirty} />

      <DeleteWithConfirmButton />
    </StyledToolbar>
  )
}

export default WithDeleteModalToolbar
